import './style.css';
import sun from './sun.svg';
import moon from './moon.svg';
import { useEffect, useRef } from 'react';
import { useLocalStorage } from '../../utils/useLocalStorage';
import detectDarkMode from '../../utils/detectDarkMode';

const ButtonDarkMode = () => {
  // const [darkMode, setDarkMode] = useState('light');
  // const [darkMode, setDarkMode] = useLocalStorage('darkMode', 'light');
  const [darkMode, setDarkMode] = useLocalStorage('darkMode', detectDarkMode());

  const btnRef = useRef(null);

  useEffect(() => {
    if (darkMode === 'dark') {
      document.body.classList.add('dark');
      btnRef.current.classList.add('dark-mode-btn--active');
    } else {
      document.body.classList.remove('dark');
      btnRef.current.classList.remove('dark-mode-btn--active');
    }
  }, [darkMode]);

  // Слушаем переключение системной темы в опереционной системе пользователя (если пользователь не выбрал вручную)
  // За сутки на компе тема в зависимости от времени может меняться
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleSystemThemeChange = event => {
      const newColorScheme = event.matches ? 'dark' : 'light';
      setDarkMode(newColorScheme);
    };

    mediaQuery.addEventListener('change', handleSystemThemeChange);
    return () =>
      mediaQuery.removeEventListener('change', handleSystemThemeChange);
  }, [setDarkMode]);

  const toggleDarkMode = () => {
    setDarkMode(prev => (prev === 'light' ? 'dark' : 'light'));
  };

  return (
    <button
      ref={btnRef}
      type="button"
      className="dark-mode-btn"
      aria-label="Toggle color theme"
      onClick={toggleDarkMode}
    >
      <img src={sun} alt="Light mode" className="dark-mode-btn__icon" />
      <img src={moon} alt="Dark mode" className="dark-mode-btn__icon" />
    </button>
  );
};

export default ButtonDarkMode;
